// Mirror of backend strip_vat_from_line_totals: some invoices print per-line totals that include VAT while unit prices are net.
const close = (a, b) => Math.abs(a - b) <= Math.max(0.02, 0.006 * Math.abs(b));
const num = (v) => (v === null || v === undefined || v === "" ? null : Number(v));

export function linesIncludeVat(lines, invoice) {
  let candidates = 0, hits = 0, sum = 0;
  for (const l of lines) {
    const q = num(l.quantity), u = num(l.unit_price), t = num(l.line_total), v = num(l.vat_rate);
    if (t) sum += t;
    if (!q || !u || !t || !v) continue;
    candidates++;
    if (close(q * u * (1 + v / 100), t) && !close(q * u, t)) hits++;
  }
  const sub = num(invoice?.subtotal), tot = num(invoice?.total);
  const sumsToGross = !!(sub && tot && tot > sub && close(sum, tot) && !close(sum, sub));
  return (candidates > 0 && hits >= Math.max(1, Math.round(0.6 * candidates))) || sumsToGross;
}

export function stripVat(lines) {
  return lines.map((l) => {
    const q = num(l.quantity), u = num(l.unit_price), t = num(l.line_total), v = num(l.vat_rate);
    if (!t || v === null) return l;
    let net = Math.round((t / (1 + v / 100)) * 100) / 100;
    if (q && u && close(q * u, net)) net = Math.round(q * u * 100) / 100;
    return { ...l, line_total: net };
  });
}
